/**
 * Anzeige-Templates der Bestellpositions-View — Port von `IwmColumnsBestellposition.razor`.
 *
 * Die Vorlage ist die umfangreichste des Altclients; sie liegt deshalb thematisch getrennt
 * unter `orderPosition/` und wird hier zu einer Zuordnung zusammengeführt.
 */

import type { OrderPosition } from '@/types/entities';

import { orderPositionBooleanTemplates } from './orderPosition/booleanTemplates';
import { orderPositionDateTemplates } from './orderPosition/dateTemplates';
import { orderPositionDeadlineTemplates } from './orderPosition/deadlineTemplates';
import { orderPositionDecimalTemplates } from './orderPosition/decimalTemplates';
import type { CellTemplateMap } from './types';

export const orderPositionCellTemplates: CellTemplateMap<OrderPosition> = {
  ...orderPositionDeadlineTemplates,
  ...orderPositionDateTemplates,
  ...orderPositionBooleanTemplates,
  ...orderPositionDecimalTemplates,
};

export default orderPositionCellTemplates;
